<template>
  <div>
    <div class="info">
      <div class="title">
        <span style="color: #377DE4;">修正</span><span style="color: #1B263B;">分销平台</span>
      </div>
      <i class="line1">无缝连接品牌，源头好货，全网底价</i>
      <div class="line2">销售通路涵盖电商、新零售、母婴、药店和 超市第三终端等多渠道</div>
      <div class="QR_code">
        <img style="width: 1.5rem;height: 1.5rem;" src="../../assets/images/wxCode.png" alt="">
        <div class="addWx">（扫码加微信）</div>
      </div>
      <!-- <div class="hotLine">招商热线：19357171223</div> -->
    </div>
    <div class="advantage">
      <div class="word">修正集团优势</div>
      <div style="display: flex;margin-top: 0.8rem;">
        <div class="left">
          <div class="line1" >
            <div>
              <img class="icon" src="../../assets/images/icon1.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">医药、保健品等品种</div>
                <div class="num">2000余个</div>
              </div>
            </div>
            <div style="margin-top: 0.4rem;">
              <img class="icon" src="../../assets/images/icon4.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">全国最大的</div>
                <div class="num">OTC市场网络</div>
              </div>
            </div>
          </div>
          <div class="line1" style="display: flex;">
            <div>
              <img class="icon" src="../../assets/images/icon2.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">独家品种</div>
                <div class="num">109个</div>
              </div>
            </div>
            <div style="margin-top: 0.4rem;">
              <img class="icon" src="../../assets/images/icon5.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">生产基地</div>
                <div class="num">34个</div>
              </div>
            </div>
          </div>
          <div class="line1" style="display: flex;">
            <div>
              <img class="icon" src="../../assets/images/icon3.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">销售过亿品种</div>
                <div class="num">50多个</div>
              </div>
            </div>
            <div style="margin-top: 0.4rem;">
              <img class="icon" src="../../assets/images/icon6.png" alt="">
              <div style="display: inline-block;margin-left: 0.2rem;">
                <div class="tip">中药材种植基地</div>
                <div class="num">33个</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <img style="width: 4.54rem;height: 3.52rem;" src="../../assets/images/vision.png" alt="">
        </div>
      </div>
    </div>
    <div class="intro">
      <div class="introTitle">集团介绍</div>
      <div class="content">
        <img class="xiu" src="../../assets/images/xiuzheng.png" alt="">
        <div class="xiuWord">
          <div class="title">修正集团</div>
          <div class="word">
            修正集团于1995年5月由董事长修涞贵创立，是集中成药、化学制药、生物制药的科研生产营销、药品连锁经营、中药材标准栽培于一体的大型现代化民营制药企业。
            至2022年底，集团下辖142个子公司，有员工6万余人。拥有24种剂型，医药、保健品等品种2千余个。通过二次开发培育了肺宁、消糜栓、六味地黄、颈康、益气养血等十几个大品种;修正拥有集科技管理、创新药物研究、新技术成果转化为一体国内的科研体系，拥有中技术专家300余人，取得授权专利700余个，荣获国家级科技进步奖7个。
            有国家认定企业技术中心、中药质量控制技术国家工程实验率、博士后科研工作站、中药标准化关键工程技术重点实验室。 建百年修正，创民族品牌，修正药业要在10年内力争实现销售收入千亿元目标，到2030年达到万亿元目标，成为世界百强制药企业。
          </div>
        </div>
      </div>
    </div>
    <div class="honor">
      <div class="title">集团荣誉</div>
      <div class="allImg">
        <img style="width: 2.5rem;height: 3.6rem;margin-right: 0.4rem;" src="../../assets/images/honor1.png" alt="">
        <div style="display: flex;flex-direction: column;justify-content: space-between;margin-right: 0.4rem;">
          <img style="width: 2.39rem;height: 1.76rem;" src="../../assets/images/honor2.png" alt="">
          <img style="width: 2.4rem;height: 1.69rem;" src="../../assets/images/honor3.png" alt="">
        </div>
        <img style="width: 6.47rem;height: 3.58rem;" src="../../assets/images/honor4.png" alt="">
      </div>
    </div>
    <div class="join">
      <div class="allJoin">
        <div :class="['item',joinType == 2 ? 'active' : '']" @click="selectSupplier(2)">经销商加盟</div>
        <div :class="['item',joinType == 1 ? 'active' : '']" @click="selectSupplier(1)">供应商合作</div>
        <div :class="['item',joinType == 3 ? 'active' : '']" @click="selectSupplier(3)">服务商加盟</div>
        <div :class="['item',joinType == 4 ? 'active' : '']" @click="selectSupplier(4)">商家入驻</div>
        <!-- <a href="https://www.xzcare.com/#/apply?mch_type=1" class="item">商家入驻</a> -->
      </div>
      <Dealer ref="dealer" :joinType="joinType" @submitApply="submitApply"></Dealer>
      <Service ref="service" :joinType="joinType" @submitApply="submitApply"></Service>
      <Supplier ref="supplier" :joinType="joinType" @submitApply="submitApply"></Supplier>
      <MerchantJoin ref="merchantJoin" :joinType="joinType"></MerchantJoin>
    </div>
    <div class="bottom">
      <div class="word">期待您的加入</div>
      <div class="code">
        <img style="width: 1.7rem;height: 1.7rem;" src="../../assets/images/wxCode.png" alt="">
      </div>
      <div class="addWx">（扫码加微信）</div>
      <!-- <div class="phone">招商热线：15941107587</div> -->
    </div>
  </div>
</template>

<script>
import Dealer from "./components/dealer";
import MerchantJoin from "./components/merchantJoin";
import Service from "./components/service";
import Supplier from "./components/supplier";
export default {
  name: '',
  data (){
    return {
      joinType:2,
      contentText: '',
      mobile: '',
      name: '',
      
    }
  },
  components: {
    Dealer,
    MerchantJoin,
    Service,
    Supplier
  },
  mounted() {
    // 在组件挂载后监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    // 初始化时设置根字体大小
    this.setRootFontSize();
  },
  methods: {
    handleResize() {
      // 窗口大小变化时重新计算根字体大小
      this.setRootFontSize();
    },
    setRootFontSize() {
      // 获取当前窗口宽度
      const dip = document.documentElement.clientWidth;
      // 根据窗口宽度计算新的根字体大小，这里假设以屏幕宽度为基准，16px为100vw
      this.rootFontSize = (dip * 100) / 1920;
      // 设置新的根字体大小
      document.documentElement.style.fontSize = this.rootFontSize + "px";
    },
    selectSupplier(index){
      this.joinType = index
    },
    submitApply(data){
      if (!data.name) {
        this.$message.warning("请输入您的姓名");
        return false;
      } else if(data.name.length>20){
        this.$message.warning("姓名不能多于20字");
        return false;
      }else if(!data.contentText){
        this.$message.warning("请输入详细信息");
        return false;
      }else if(data.contentText.length>300){
        this.$message.warning("详细信息不能多于300字");
        return false;
      }else if (!(/^1[3456789]\d{9}$/.test(data.mobile))) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      let params = {
        name: data.name,
        mobile: data.mobile,
        type: this.joinType,
        content: data.contentText,
        company_name: data.company_name,
        region:data.region,
        channels: data.channels,
        shop_name:data.shop_name,
        product:data.product,
        services:data.services,
        product_cat:data.product_cat,
        hot_products:data.hot_products
      }
      const currentTime = Date.now()
      // 如果上次提交时间为null或距离上次提交时间大于一分钟，则可以提交
      if (!this.lastSubmitTime || currentTime - this.lastSubmitTime >= 60000) {
        // 执行提交申请的逻辑
        this.$api.investmentSubmit(params).then((res) => {
          this.$message.success(res.msg);
          if(this.joinType == 1){
            this.$refs.supplier.form = {}
          }else if(this.joinType == 2){
            this.$refs.dealer.form = {}
          }else if(this.joinType == 3){
            this.$refs.service.form = {}
          }
        }).catch((err) => {
          this.common.message(this, err)
        });

        // 更新上次提交时间为当前时间
        this.lastSubmitTime = currentTime;
      } else {
        let time = parseInt((60000 - (currentTime - this.lastSubmitTime))/1000)
        this.$message.warning('请' + time + '秒后再次提交');
        console.log('一分钟内只能提交一次');
      }


    }
  },
}
</script>

<style lang="scss" scoped>
.info{
  background: url("../../assets/images/investBg.png") no-repeat;
  background-size: 100% auto;
  padding: 1.4rem 0 0.7rem 3.6rem;
  position: relative;
  .title{
    font-family: OPPOSans-B, OPPOSans-B;
    font-weight: 600;
    font-size: 0.58rem;
    text-transform: none;
    -webkit-text-stroke: 0.02rem #FFFFFF;
    margin-bottom: 0.32rem;
    span{
      font-size: inherit;
    }
  }
  .line1{
    font-family: OPPOSans-B, OPPOSans-B;
    font-weight: normal;
    font-size: 0.28rem;
    color: #1C283F;
  }
  .line2{
    width: 6.05rem;
    font-family: OPPOSans-M, OPPOSans-M;
    font-weight: normal;
    font-size: 0.30rem;
    color: #1C283F;
    margin-top: 0.1rem;
  }
  .QR_code{
    margin: 0.5rem 0 0.4rem;
    .addWx{
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.18rem;
      color: #495A7B;
      margin-left: 0.05rem;
      margin-top: 0.03rem;
    }
  }
  .hotLine{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.34rem;
    color: #1C283F;
  }
}
.advantage{
  background: url("../../assets/images/advantageBg.png") no-repeat;
  background-size: 100% auto;
  padding: 1.02rem 3.4rem 1.26rem;
  .word{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.36rem;
    color: #232323;
    text-align: center;
  }
  .left{
    display: flex;
    margin-top: 1.04rem;
    .line1{
      display: flex;
      flex-direction: column;
      margin-left: 0.4rem;
      .icon{
        width: 0.5rem;
        height: 0.5rem;
      }
      .tip{
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.19rem;
        color: #B4B5B7;
      }
      .num{
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.26rem;
        color: #232323;
      }
    }
  }
  .right{
    margin-left: 0.5rem;
  }
}
.intro{
  background: url("../../assets/images/introBg.png") no-repeat;
  background-size: 100% auto;
  padding: 0.57rem 0 0.67rem;
  .introTitle{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.36rem;
    color: #FFFFFF;
    margin-left: 3.6rem;
  }
  .content{
    display: flex;
    .xiu{
      margin: 0.3rem 1.8rem 0 3.6rem;
      width: 3.08rem;
      height: 3.73rem;
    }
    .xiuWord{
      .title{
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.28rem;
        color: #FFFFFF;
        margin-bottom: 0.3rem;
      }
      .word{
        width: 7.06rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #FFFFFF;
      }
    }
  }
}
.honor{
  padding: 0.68rem 0 0.65rem 3.6rem;
  background: #F5F7F9;
  .title{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.36rem;
    color: #232323;
    margin-bottom: 0.5rem;
  }
  .allImg{
    display: flex;
  }
}
.join{
  padding: 0.6rem 0 0.81rem;
  .allJoin{
    margin: 0 4rem;
    display: flex;
    justify-content: space-between;
    .item{
      width: 2rem;
      height: 1.3rem;
      box-sizing: border-box;
      padding-top: 0.38rem;
      text-align: center;
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.26rem;
      color: #666666;
      cursor: pointer;
    }
    .active{
      background: #4089FE;
      position: relative;
      color: #FFFFFF;
    }
    .active::after{
      content: url('../../assets/images/triangle.png');
      display: block;
      position: absolute;
      bottom: 0.05rem;
      left: 0.9rem;
    }
  }
}
.bottom{
  text-align: center;
  background: #F5F7F9;
  padding: 0.85rem 0 0.81rem;
  .word{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.36rem;
    color: #232323;
  }
  .code{
    margin-left: 8.6rem;
    margin-top: 0.5rem;
    width: 1.83rem;
    height: 1.83rem;
    box-sizing: border-box;
    text-align: center;
    padding-top: 0.05rem;
    background: #FFFFFF;
    border-radius: 0.12rem;
    border: 0.04rem solid #4089FE;
  }
  .addWx{
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.18rem;
    color: #495A7B;
    margin-top: 0.1rem;
  }
  .phone{
    margin-top: 0.3rem;
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 0.30rem;
    color: #232323;
  }
}
</style>
